// We'll use Session Storage to store the selected cards during the session
// The cache is set on unmount (user visiting the help page for example) and set on mount
const webStorage = {
  get(id) {
    let item = null;
    if (window.sessionStorage && window.sessionStorage.getItem(id)) {
      item = JSON.parse(window.sessionStorage.getItem(id));
    }
    return item;
  },
  set(id, item) {
    if (window.sessionStorage) {
      window.sessionStorage.setItem(id, JSON.stringify(item));
    }
    return item;
  },
};

export default webStorage;
